/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandard {
    getFixupPrototypeFunction() { return ComplianceStandard.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandard>): ComplianceStandard {
        let obj = Object.assign(new ComplianceStandard(), model);
        ComplianceStandard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandard>): ComplianceStandard {
        if (!model) return null;
        return ComplianceStandard.newInstance(<ComplianceStandard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandard) {
        if (!obj) return;

        models.ComplianceStandard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandard): boolean {
        Object.setPrototypeOf(obj, ComplianceStandard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Return all of the Services given the tenant as input
     */
    services: any;

    /**
     * Return all of the Cloud accounts given the tenant as input
     */
    cloud_accounts: any;

    /**
     * ID for tenant
     */
    id: string;

    name: string;

}
